<template>
  <v-dialog
    v-model="show"
    max-width="600"
    persistent
  >
    <v-toolbar>
      <v-toolbar-title>
        <v-icon>mdi-file-send</v-icon>
        <span>Enviar Processo para Revisão</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-form v-model="valid">
          <v-layout>
            <v-flex xs6>
              <v-select
                v-model="administrativeUnit"
                label="Setor"
                :items="administrativeUnits"
                item-text="au.name"
                item-value="au.id"
                solo
                flat
                :rules="[validationRules.required]"
                @input="employee = null"
                no-data-text="Setor não encontrado"
              />
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                ref="employee"
                v-model="employee"
                label="Colaborador"
                :items="availableUsers"
                item-text="name"
                item-value="id"
                solo
                flat
                :rules="[validationRules.required]"
                clearable
                no-data-text="Colaborador não encontrado!"
                @input="$refs.employee.blur()"
                :disabled="administrativeUnit === null"
              >
                <template
                  slot="selection"
                  slot-scope="{ item, selected }"
                >
                  <v-list-tile-avatar
                    class="mr-1"
                    slot="activator"
                    v-if="item.avatar !== null"
                  >
                    <img :src="item.avatar" />
                  </v-list-tile-avatar>
                  <v-list-tile-avatar
                    class="mr-1"
                    color="grey lighten-2"
                    v-else
                  >
                    <span>{{ acronym(item.name) }}</span>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="shortName(item.name)"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.role.name"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>

                <template
                  slot="item"
                  slot-scope="{ item }"
                >
                  <v-list-tile-avatar
                    class="mr-1"
                    slot="activator"
                    v-if="item.avatar !== null"
                  >
                    <img :src="item.avatar" />
                  </v-list-tile-avatar>
                  <v-list-tile-avatar
                    class="mr-1"
                    color="grey lighten-2"
                    v-else
                  >
                    <span>{{ acronym(item.name) }}</span>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="shortName(item.name)"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.role.name"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn
            flat
            @click="$emit('close')"
            :disabled="loading"
          >
            Fechar
          </v-btn>
          <v-btn
            class="white--text"
            color="blue darken-1"
            @click="sendFolderToReview"
            :loading="loading"
            :disabled="loading || !valid"
          >
            Confirmar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import foldersService from '@/services/FoldersService';
import usersService from '@/services/UserService';
import transactionsService from '@/services/TransactionsService';
import validationRules from '@/mixins/validation-rules';
import acronym from '@/utils/acronym';
import shortName from '@/utils/short-name';
import { isEmpty } from 'lodash';

export default {
  name: 'SendFolderToReviewDialog',
  data() {
    return {
      acronym,
      administrativeUnits: [],
      administrativeUnit: null,
      employee: null,
      employees: [],
      loading: false,
      shortName,
      valid: false,
      validationRules,
    };
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    getAdministrativeUnits() {
      this.loading = true;
      foldersService.permittedAdministrativeUnits(this.folder.id)
        .then(({ data }) => {
          this.administrativeUnits = data.administrative_units;
        })
        .catch((err) => {
          this.onRequestError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getEmployees() {
      this.loading = true;
      usersService.getUsers()
        .then(({ data }) => {
          this.employees = data;
        })
        .catch((err) => {
          this.onRequestError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRequestError(err) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: err.message || err[0],
        button: { show: true, text: 'Fechar', message: '' },
        timeout: 6000,
        messageIcon: 'mdi-alert-outline',
      });
    },
    sendFolderToReview() {
      const body = {
        folder_id : this.folder.id, // eslint-disable-line
        transaction: {
          destination_id: this.administrativeUnit, // eslint-disable-line
          to_user_id : this.employee, // eslint-disable-line
        },
      };
      transactionsService.sendFolderToReview(body)
        .then(() => {
          this.onSendFolderToReviewSuccess();
        })
        .catch((err) => {
          this.onRequestError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSendFolderToReviewSuccess() {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'success',
        message: 'O processo foi enviado para revisão.',
        button: { show: true, text: 'Fechar', message: '' },
        timeout: 6000,
      })
        .then(() => {
          this.$store.dispatch('getActiveFolder', { id: this.folder.id, loading: true });
        });
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    availableUsers() {
      if (!isEmpty(this.employees)) {
        return this.employees.filter(employee =>
          employee.administrative_unit &&
          employee.administrative_unit.id === this.administrativeUnit &&
          employee.id !== this.user.id,
        );
      }
      return [];
    },
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    folder(){
      this.getAdministrativeUnits();
      this.getEmployees();
    }
  }
};
</script>

<style scoped>
  .folder-container {
    border: 1px solid;
    border-radius: 3px;
    position: relative;
  }
  .folder-type-border {
    position: absolute;
    height: 100%;
    left: -1px;
    top: 0px;
    border-radius: 3px 0 0 3px;
    border-left: 5px solid;
    transition: ease-in-out .15s;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/SendFolderToReviewDialog.vue